// Switches for policy features that wait on the backend. All off by default;
// an option behind a switched-off flag doesn't appear at all (no "coming soon").
//
// To turn one on (local mode, screenshots), set localStorage "policyFlags" to
// JSON, e.g. in the browser console:
//   localStorage.setItem("policyFlags", JSON.stringify({ appliedColumn: true }))
// and reload. Unknown keys are ignored.
//
// Country, Risk, one-time time windows and IP ranges are not flags: the
// editor doesn't offer them at all (a stored one shows read-only).
export const DEFAULT_POLICY_FLAGS = {
  // List "Applied" column and the detail page's "Applied N times" line.
  appliedColumn: false,
};

export const POLICY_FLAGS_KEY = "policyFlags";

export function getPolicyFlags() {
  let overrides = {};
  try {
    const raw = window.localStorage.getItem(POLICY_FLAGS_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    if (parsed && typeof parsed === "object") overrides = parsed;
  } catch {
    overrides = {};
  }
  const out = { ...DEFAULT_POLICY_FLAGS };
  Object.keys(DEFAULT_POLICY_FLAGS).forEach((k) => {
    if (k in overrides) out[k] = !!overrides[k];
  });
  return out;
}
